import { getCurrentThemeId, getPaletteAsRawColors, getIsWin32ColorfulLightTheme } from 'owa-theme';
import { ThemeConstants } from 'owa-theme-shared';
import generateSuitePaletteFromFabricPalette from './generateSuitePaletteFromFabricPalette';
import React from 'react';
import {
    BASE_LIGHT_THEME_PALETTE,
    OFFICENEUTRAL_LIGHT_THEME_PALETTE_DIFF_BASE,
} from 'owa-theme-common';
import type { BaseTheme } from '@1js/suiteux-shell-react';

export default function useOwaBrandTheme(): BaseTheme {
    /**
     * When the UserThemeId is set to 'base', the Shell uses an AppBrandTheme palette, if provided.
     * Classic Outlook style uses the active Win32 Colorful header palette, refreshing when
     * the checkbox changes even if the theme Id stays the same. Otherwise, use the 'base'
     * palette, or the OfficeNeutral palette when an OfficeNeutral theme is selected.
     */
    const themeId = getCurrentThemeId();
    const isWin32Colorful = getIsWin32ColorfulLightTheme();

    return React.useMemo(() => {
        if (isWin32Colorful) {
            return generateSuitePaletteFromFabricPalette(getPaletteAsRawColors(themeId, false));
        }

        return themeId === ThemeConstants.OFFICE_NEUTRAL_THEME_ID ||
            themeId === ThemeConstants.MODERN_OFFICE_NEUTRAL_THEME_ID
            ? generateSuitePaletteFromFabricPalette({
                  ...BASE_LIGHT_THEME_PALETTE,
                  ...OFFICENEUTRAL_LIGHT_THEME_PALETTE_DIFF_BASE,
              })
            : generateSuitePaletteFromFabricPalette(BASE_LIGHT_THEME_PALETTE);
    }, [themeId, isWin32Colorful]);
}
